import { useRef } from "react";
import { motion, useInView, useScroll, useTransform } from "framer-motion";
import { useSectionTracking } from "./AnalyticsProvider";

export default function AmbientVideo() {
  const sectionRef = useSectionTracking("ambient_video");
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: containerRef, offset: ["start end", "end start"] });
  const opacity = useTransform(scrollYProgress, [0, 0.3, 0.7, 1], [0, 1, 1, 0]);
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [0.95, 1, 0.95]);
  const animRef = useRef(null);
  const inView = useInView(animRef, { once: true, margin: "-100px" });

  return (
    <section ref={sectionRef} className="relative py-10 lg:py-16" data-testid="ambient-video-section">
      <div ref={containerRef} className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          ref={animRef}
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-8"
        >
          <p className="font-serif text-xl sm:text-2xl italic text-[#C5A059]/70">
            A specimen most gemologists will never encounter in their lifetime
          </p>
        </motion.div>

        <motion.div style={{ opacity, scale }} className="relative overflow-hidden">
          <video
            autoPlay muted loop playsInline
            poster="/media/photos/new_5.jpg"
            className="w-full h-[40vh] sm:h-[50vh] lg:h-[60vh] object-cover"
            data-testid="ambient-video-player"
          >
            <source src="/media/videos/BridgetteV.3.mp4" type="video/mp4" />
          </video>
          <div className="absolute inset-0 bg-gradient-to-t from-[#111110] via-transparent to-[#111110]/30 pointer-events-none" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#111110]/20 to-[#111110]/20 pointer-events-none" />

          <div className="absolute bottom-6 left-6 lg:bottom-8 lg:left-8">
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 bg-[#C5A059]/40 rounded-full animate-pulse" />
              <span className="text-xs text-[#B8B3AA]/60 uppercase tracking-wider">Live specimen footage</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
